import React, { useEffect, createElement } from 'react';
const FONT_URL = 'https://fonts.googleapis.com/css2?family=Fraunces:ital,opsz,wght@0,9..144,500;1,9..144,400&family=Inter:wght@400;500;600;700&display=swap';
export function FontLoader() {
  useEffect(() => {
    // Set html lang attribute
    document.documentElement.lang = 'es-AR';
    // Set document title
    document.title = 'El Origen de Tus Bloqueos — Sistema para sanar patrones generacionales';
    // Ensure charset meta exists
    if (!document.querySelector('meta[charset]')) {
      const charset = document.createElement('meta');
      charset.setAttribute('charset', 'UTF-8');
      document.head.prepend(charset);
    }
    // Helper to create/update meta tags
    const setMeta = (attr: string, key: string, content: string) => {
      let el = document.querySelector(`meta[${attr}="${key}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.content = content;
      return el;
    };
    // Meta description
    const metaDesc = setMeta('name', 'description', 'Dejá de trabajar el síntoma. Entendé el origen generacional de tus patrones emocionales con el primer sistema en español basado en epigenética y psicología transgeneracional. Sola, en privado, a tu ritmo.');
    // Open Graph tags
    const ogTitle = setMeta('property', 'og:title', 'El Origen de Tus Bloqueos — Sistema para sanar patrones generacionales');
    const ogDesc = setMeta('property', 'og:description', 'El primer sistema en español que te enseña a trazar el origen generacional de tus patrones emocionales. Con base científica. Sola. A tu ritmo.');
    const ogType = setMeta('property', 'og:type', 'website');
    const ogLocale = setMeta('property', 'og:locale', 'es_AR');
    // Twitter Card tags
    const twCard = setMeta('name', 'twitter:card', 'summary_large_image');
    const twTitle = setMeta('name', 'twitter:title', 'El Origen de Tus Bloqueos');
    const twDesc = setMeta('name', 'twitter:description', 'Dejá de trabajar el síntoma. Entendé el origen.');
    // --- Font loading (existing) ---
    const preconnect1 = document.createElement('link');
    preconnect1.rel = 'preconnect';
    preconnect1.href = 'https://fonts.googleapis.com';
    document.head.appendChild(preconnect1);
    const preconnect2 = document.createElement('link');
    preconnect2.rel = 'preconnect';
    preconnect2.href = 'https://fonts.gstatic.com';
    preconnect2.crossOrigin = 'anonymous';
    document.head.appendChild(preconnect2);
    const fontLink = document.createElement('link');
    fontLink.rel = 'preload';
    fontLink.as = 'style';
    fontLink.href = FONT_URL;
    fontLink.onload = () => {
      fontLink.onload = null;
      fontLink.rel = 'stylesheet';
    };
    document.head.appendChild(fontLink);
    const noscript = document.createElement('noscript');
    const fallbackLink = document.createElement('link');
    fallbackLink.rel = 'stylesheet';
    fallbackLink.href = FONT_URL;
    noscript.appendChild(fallbackLink);
    document.head.appendChild(noscript);
    return () => {
      // Cleanup font links
      document.head.removeChild(preconnect1);
      document.head.removeChild(preconnect2);
      document.head.removeChild(fontLink);
      document.head.removeChild(noscript);
      [metaDesc, ogTitle, ogDesc, ogType, ogLocale, twCard, twTitle, twDesc].forEach(el => {
        if (el && el.parentNode) el.parentNode.removeChild(el);
      });
    };
  }, []);
  return null;
}